define('lq/events/actions/bigBlueButtonJoinMeetingCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

        function BigBlueButtonJoinMeetingCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(BigBlueButtonJoinMeetingCommand, EventAction);

    BigBlueButtonJoinMeetingCommand.typeName = 'BigBlueButtonJoinMeetingCommand';

    BigBlueButtonJoinMeetingCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    BigBlueButtonJoinMeetingCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: "JoinMeeting",
            morphId: this.eventData.command
        };
    };

    BigBlueButtonJoinMeetingCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse.success) {
            this.joined(continuation, eventActionResponse);
        } else {
            if (this.eventIsEnabled('joinFailed'))
                this.triggerEvent('joinFailed', continuation);
            else {
                alert('Could not join the meeting.');
                continuation();
            }
        }
    };

    BigBlueButtonJoinMeetingCommand.prototype.joined = function (continuation, eventActionResponse) {
        if (this.eventIsEnabled('joinedMeeting'))
            this.triggerEvent('joinedMeeting', continuation, eventActionResponse.redirectUrl);
        else
            continuation();
    };

    return BigBlueButtonJoinMeetingCommand;
});
